module.exports = __webpack_public_path__ + "img/14.2e0c20ac.png";